module.exports = __webpack_public_path__ + "static/media/McGill.2774d099.svg";